module.exports = __webpack_public_path__ + "img/holding-icon.9d446e05.svg";